<template>
    <div class="head">
        <div style="display: flex;justify-content: space-between;height: 40px;">
            <div class="tabcapsule" @click="$router.replace('/brandnew/brandnewModel');">前段展示</div>
            <div class="tabcapsule" @click="$router.replace('/brandnew/brandnewSort');">分类设置</div>
            <div class="tabcapsule">标题设置</div>
            <div class="tabcapsule">分享设置</div>
            <div class="tabcapsule" @click="$router.replace('/express/expressList');">快递设置</div>
            <div class="tabcapsule" @click="dialogVisible('dialogpayVisible')">收款设置</div>
            <div class="tabcapsule">代理设置</div>
            <div class="tabcapsule">视频教学</div>
            <div class="tabcapsule">订单管理</div>
            <el-dropdown @command="handleCommand" style="margin: 0 5px;width: 9%;min-width: 120px;">
                <div style="display: flex;align-items: center;">
                    <el-image style="width: 55px; height: 55px" src="https://kaifaceshi.08170817.com/static/admin/head.png" fit="fill"></el-image>
                    <div style="margin-left: 10px;font-size: 18px;color: #fff;">{{ supplierinfo.suppliername.length>5?supplierinfo.suppliername.substring(0,5):supplierinfo.suppliername }}</div>
                    <span class="el-icon-caret-bottom" style="color: #fff;"></span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item command="editpwd">续费关联</el-dropdown-item> -->
                        <el-dropdown-item command="editpwd">修改密码</el-dropdown-item>
                        <el-dropdown-item command="loginOut">注销登录</el-dropdown-item>
                    </el-dropdown-menu>
                </div>
            </el-dropdown>
        </div>
         <!-- 支付配置 -->
        <el-dialog title="支付配置" :visible.sync="dialogpayVisible" width="50%" top="5vh" :modal-append-to-body="false" :close-on-click-modal="false" v-if="dialogpayVisible" style="z-index: 9999;">
            <el-form ref="rules" label-width="100px" class="demo-ruleForm">
                <el-tabs value ="first">
                    <el-tab-pane label="微信收款" name="first">
                        <el-form-item label="商户号:">
                            <el-input v-model="supplierinfo.huifu_id"></el-input>
                        </el-form-item>
                        <el-form-item label="商户秘钥:">
                            <el-input v-model="supplierinfo.huifu_rsaPrivateKey"></el-input>
                        </el-form-item>
                        <el-form-item label="支付类型:">
                            <el-radio-group v-model="supplierinfo.paytype">
                                <el-radio :label="1">商户号模式</el-radio>
                                <el-radio :label="2">二维码模式</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label="二维码收款" name="second">
                        <el-form-item label="户名:">
                            <el-input v-model="supplierinfo.bankuname"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行:">
                            <el-input v-model="supplierinfo.bankname"></el-input>
                        </el-form-item>
                        <el-form-item label="银行卡号:">
                            <el-input v-model="supplierinfo.bankcode"></el-input>
                        </el-form-item>
                        <el-form-item label="扫码支付:">
                            <div style="margin-top: 20px;">
                                <div style="display: flex;margin-left: 10px; flex-direction:row;align-items: center; margin-top: 20px;">
                                    <div style="display: flex; flex-direction:column;align-items: center;" v-for="(item,index) in supplierinfo.payimg">
                                        <div>
                                            <el-image style="width: 100px; height: 100px" :src="item"
                                                fit="fill">
                                            </el-image>
                                        </div>
                                        <div>
                                            <el-button type="danger" size="mini" plain
                                                @click="delepayImg(index)">删除</el-button>
                                        </div>
                                    </div>
                                    <div>
                                        <el-upload action="https://kaifaceshi.08170817.com/admin/index/imgUpload" :show-file-list="false"
                                            :multiple="true" :auto-upload="true" :on-success="addpayImg">
                                            <el-button size="small" type="primary" v-if="supplierinfo.payimg.length<3">点击上传</el-button>
                                        </el-upload>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="微信客服:">
                            <div style="margin-top: 20px;">
                                <div style="display: flex;margin-left: 10px; flex-direction:row;align-items: center; margin-top: 20px;">
                                    <div style="display: flex; flex-direction:column;align-items: center;" v-for="(item,index) in supplierinfo.wximg">
                                        <div>
                                            <el-image style="width: 100px; height: 100px" :src="item"
                                                fit="fill">
                                            </el-image>
                                        </div>
                                        <div>
                                            <el-button type="danger" size="mini" plain
                                                @click="delewxImg(index)">删除</el-button>
                                        </div>
                                    </div>
                                    <div>
                                        <el-upload action="https://kaifaceshi.08170817.com/admin/index/imgUpload" :show-file-list="false"
                                            :multiple="true" :auto-upload="true" :on-success="addwxImg">
                                            <el-button size="small" type="primary" v-if="supplierinfo.wximg.length<3">点击上传</el-button>
                                        </el-upload>
                                    </div>
                                </div>
                                
                            </div>
                        </el-form-item>
                        <el-form-item label="QQ客服:">
                            <div style="margin-top: 20px;">
                                <div style="display: flex;margin-left: 10px; flex-direction:row;align-items: center; margin-top: 20px;">
                                    <div style="display: flex; flex-direction:column;align-items: center;" v-for="(item,index) in supplierinfo.qqimg">
                                        <div>
                                            <el-image style="width: 100px; height: 100px" :src="item"
                                                fit="fill">
                                            </el-image>
                                        </div>
                                        <div>
                                            <el-button type="danger" size="mini" plain
                                                @click="deleqqImg(index)">删除</el-button>
                                        </div>
                                    </div>
                                    <div>
                                        <el-upload action="https://kaifaceshi.08170817.com/admin/index/imgUpload" :show-file-list="false"
                                            :multiple="true" :auto-upload="true" :on-success="addqqImg">
                                            <el-button size="small" type="primary" v-if="supplierinfo.qqimg.length<3">点击上传</el-button>
                                        </el-upload>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </el-tab-pane>
                </el-tabs>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogpayVisible = false">取 消</el-button>
                <el-button type="primary" @click="edithuifu">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
    
    data(){
        return{
            dialogpayVisible:false,
            supplierinfo:{},
        }
    },
    created(){
       this.getdata()
     
    },
    methods:{
        async getdata(){
            let res = await this.$api.getSupplierinfo();
            this.supplierinfo = res.data.data
            // console.log('this.supplierinfo',this.supplierinfo)
        },
        handleCommand(command){
            console.log('123', command)
            if (command == 'loginOut'){
                // localStorage.removeItem('info/')
                localStorage.removeItem('info')
                this.$router.push('/login')
            }
            if (command == 'editpwd'){
                this.dialogTableVisible = true
            }
        },
        async edithuifu(){
            this.supplierinfo.payimg = JSON.stringify(this.supplierinfo.payimg)
            this.supplierinfo.wximg = JSON.stringify(this.supplierinfo.wximg)
            this.supplierinfo.qqimg = JSON.stringify(this.supplierinfo.qqimg)

            let res= await this.$api.edithuifu(this.supplierinfo)
            if(res.data.code==200){
                this.$message({
                    message: '修改成功！',
                    type: 'success',
                    duration: 1000
                });
                this.getdata()
                this.dialogpayVisible = false
            }
        },
        dialogVisible(operate){
            if(operate=='dialogpayVisible'){
                this.dialogpayVisible = true
            }
        },
        addpayImg(file){
            this.supplierinfo.payimg.push(file.data);
        },
        delepayImg(index){
            this.supplierinfo.payimg.splice(index, 1);
        },
        addwxImg(file){
            this.supplierinfo.wximg.push(file.data);
        },
        delewxImg(index){
            this.supplierinfo.wximg.splice(index, 1);
        },
        addqqImg(file){
            this.supplierinfo.qqimg.push(file.data);
        },
        deleqqImg(index){
            this.supplierinfo.qqimg.splice(index, 1);
        },
    }
}
</script>

<style lang="less" >
    .head{
        display: grid;
        align-items: center;
        height: 60px;
        background: linear-gradient(to bottom, #017D7C, #12a8a8);
        color: #fff;
        width: fit-content;
        // min-width: 1280px;
        min-width: 1758px;
        line-height: 50px;
        z-index: 999;
        width: -webkit-fill-available;
        padding: 15px 15px;
    }
    .tabcapsule{
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        width: 7%;
        min-width: 100px;
        margin: 0 5px;
        background-image: url('https://kaifaceshi.08170817.com/static/admin/tabcapsule.png');
        background-size: 100% 100%;
        font-size: 16px;
        font-weight: 600;
    }
</style>